import { AgnosticShipmentSort } from '../domain/AgnosticShipmentSort'

export function mapAgnosticShipmentSortToApi(sort?: AgnosticShipmentSort): string | undefined {
  switch (sort) {
    case AgnosticShipmentSort.Status:
      return 'status,pickup__date'
    case AgnosticShipmentSort.PickupAsc:
      return 'pickup__date,status'
    case AgnosticShipmentSort.PickupDesc:
      return '-pickup__date,status'
    default:
      return undefined
  }
}
